import React from "react";
import styled from "styled-components";
import {ButtonWidget} from "../widget/pub/button_widget";
import {getBalanceNumber} from "../utils/formatBalance";
import {useWait} from "../utils/wait_fn";
import {LoadingModal} from "./http_loading";
import {HttpServer} from "../net/http_server";

export const StakeModel: React.FC<{
    onDismiss?: () => void, amount: any, handleChallenge: Function, success?: React.FC<any>,
}> = ({
          onDismiss,
          amount,
          handleChallenge,
                                   success
      }) => {

    const {data, request, status} = useWait<any>(handleChallenge);
    let available = getBalanceNumber(amount.available), chaAmount = getBalanceNumber(amount.chaAmount);
    return (
        <LoadingModal data={data} success={success} status={status}>
            <StakeStyle>
                <h3>To apply for challenging, 10 times the amount of premium staked is required in Nsure tokens.
                    Would you like to confirm this challenge?</h3>

                <div className={'box'}>
                    <h2>Requested Stake amount for challenge:</h2>
                    <h4>{chaAmount} <span>Nsure</span></h4>
                </div>
                <h5>Available : <span>{available}</span><span>Nsure</span></h5>
                <div className={'buttons'}>
                    <ButtonWidget onClick={onDismiss} size={{x: 8, y: 35}} bgColor={'#0064FD'} text={'Cancel'}/>
                    <ButtonWidget disable={available < chaAmount} onClick={request} size={{x: 8, y: 35}}
                                  bgColor={'#0064FD'} text={'confirm'}/>
                </div>
            </StakeStyle>

        </LoadingModal>
    );
}


const StakeStyle = styled.div`
  width: 368px;
  //height: 355px;
  background: linear-gradient(270deg, #E3EFFF 0%, #FAF0FF 100%);
  box-shadow: 0px 0px 16px 1px rgba(126, 126, 126, 0.45);
  border-radius: 12px;
  padding: 30px 40px;
  box-sizing: border-box;

  .buttons {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
  }

  h5 {
    font-size: 9px;
    font-weight: 400;
    color: #666666;
    line-height: 13px;
    display: flex;

    span {
      display: block;
      margin-left: 6px;
      font-size: 10px;
      font-weight: 400;
      color: #270D4F;
    }
  }

  h3 {

    box-sizing: border-box;
    font-size: 11px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }

  .box {
    padding: 15px 0;
    box-sizing: border-box;
    background-color: #E2DFFF;
    margin: 30px 0 10px 0;
    text-align: center;

    h2 {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 1.3;
    }

    h4 {
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #270D4F;
      line-height: 1.3;
      margin-top: 15px;

      span {
        font-size: 9px;
        font-weight: 400;
        color: #5D376B;
      }
    }
  }


`
